var _path, _path2, _mask, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleplayicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.154096 2.05331H0.154321L0.153872 2.04511C0.130859 1.62495 0.262418 1.21141 0.523037 0.880745L12.1697 12.4193V12.5776L0.526637 24.1219C0.258877 23.7932 0.125345 23.3762 0.153758 22.9536L0.154096 22.9536V22.9435V2.05331Z",
    fill: "white",
    stroke: "#8261C2",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9147 11.27L20.9145 11.2699L16.2456 8.64891L12.4703 12.4196V12.5786L16.2582 16.3618L16.2625 16.3599L20.914 13.738L20.9147 11.27ZM20.9147 11.27C21.5543 11.6279 21.838 12.0798 21.838 12.5003M20.9147 11.27L21.838 12.5003M21.838 12.5003C21.838 12.921 21.5541 13.3752 20.9143 13.7378L21.838 12.5003Z",
    fill: "white",
    stroke: "#8261C2",
    strokeWidth: 0.3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_4419_239362",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3405 16.4844L12.3211 12.499L0.453125 24.2663C0.722272 24.5038 1.06678 24.6405 1.4269 24.6526C1.78702 24.6647 2.14005 24.5514 2.42477 24.3324L16.3405 16.4844Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3405 16.4844L12.3211 12.499L0.453125 24.2663C0.722272 24.5038 1.06678 24.6405 1.4269 24.6526C1.78702 24.6647 2.14005 24.5514 2.42477 24.3324L16.3405 16.4844Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3211 12.499L12.5323 12.286L12.3211 12.0766L12.1098 12.286L12.3211 12.499ZM0.453125 24.2663L0.241898 24.0533L0.0141929 24.279L0.254611 24.4912L0.453125 24.2663ZM2.42477 24.3324L2.2774 24.0711L2.2588 24.0816L2.24187 24.0946L2.42477 24.3324ZM16.5518 16.2714L12.5323 12.286L12.1098 12.7121L16.1293 16.6974L16.5518 16.2714ZM12.1098 12.286L0.241898 24.0533L0.664352 24.4793L12.5323 12.7121L12.1098 12.286ZM0.254611 24.4912C0.576191 24.775 0.987397 24.938 1.41685 24.9524L1.43695 24.3527C1.14616 24.343 0.868353 24.2326 0.651639 24.0414L0.254611 24.4912ZM1.41685 24.9524C1.84629 24.9668 2.26758 24.8318 2.60766 24.5702L2.24187 24.0946C2.01252 24.271 1.72775 24.3625 1.43695 24.3527L1.41685 24.9524ZM2.57213 24.5937L16.4879 16.7457L16.1932 16.2231L2.2774 24.0711L2.57213 24.5937Z",
    fill: "#8261C2",
    mask: "url(#path-3-inside-1_4419_239362)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33215 0.792992L2.34117 0.800066L2.35115 0.805689L16.094 8.54682L12.3211 12.2877L0.67926 0.744645C0.89962 0.591747 1.16139 0.505058 1.43285 0.497257C1.75854 0.487896 2.07697 0.592701 2.33215 0.792992Z",
    fill: "white",
    stroke: "#8261C2",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.2262 16.3989L2.42477 24.1903C2.1504 24.3956 1.81602 24.5066 1.47228 24.5066C1.12854 24.5066 0.794167 24.3956 0.519799 24.1903L0.453125 24.2564L0.519799 24.3319C0.794167 24.5372 1.12854 24.6483 1.47228 24.6483C1.81602 24.6483 2.1504 24.5372 2.42477 24.3319L16.3405 16.4839L16.2262 16.3989Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M0.455808 24.1334C0.149864 23.7588 -6.86981e-05 23.2824 0.0367144 22.8018V22.9434C0.00430515 23.4254 0.165198 23.9006 0.484381 24.2656L0.551057 24.1995L0.455808 24.1334Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M20.989 13.7267L16.2266 16.3994L16.3123 16.4844L20.989 13.859C21.265 13.7432 21.5045 13.5558 21.6822 13.3165C21.8599 13.0772 21.9692 12.7948 21.9986 12.499C21.9391 12.7678 21.8167 13.0189 21.6413 13.2321C21.4659 13.4454 21.2425 13.6148 20.989 13.7267Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M2.42712 0.806654L20.991 11.2707C21.2445 11.3826 21.468 11.552 21.6433 11.7653C21.8187 11.9785 21.9411 12.2296 22.0007 12.4984C21.9712 12.2026 21.8619 11.9202 21.6842 11.6809C21.5066 11.4416 21.2671 11.2542 20.991 11.1384L2.42712 0.674436C1.10317 -0.0810876 0.0078125 0.54222 0.0078125 2.05327V2.19493C0.036387 0.683881 1.10317 0.0605743 2.42712 0.806654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplayicon);
export default __webpack_public_path__ + "static/media/googleplayicon.ac8679ba2b62bc74ba79041db831c4ee.svg";
export { ForwardRef as ReactComponent };